<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="TraderecordRespVo" ref="queryForm" label-width="auto" size="small" inline>
        <div class="query-grid">

<!--          <el-form-item :label="$t('startDate')" prop="startDate">
            <el-date-picker
              v-model="TraderecordRespVo.startDate"
              type="datetime"

              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              popper-class="no-now-btn"
              class="full-width"
              :picker-options="startDatePickerOptions"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>



          <el-form-item :label="$t('endDate')" prop="endDate">
            <el-date-picker
              v-model="TraderecordRespVo.endDate"
              type="datetime"

              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
              popper-class="no-now-btn"
              :picker-options="endDatePickerOptions"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>-->
          <el-form-item :label="$t('date')" prop="dateRange">

            <el-date-picker

                v-model="TraderecordRespVo.dateRange"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('startDate')"
                :end-placeholder="$t('endDate')"

                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="full-width"
                :default-time="['00:00:00','23:59:59']"
                :picker-options="pickerOptions"
            />

          </el-form-item>



          <el-form-item :label="$t('showMerTranSactionSettlemenListInfo.hkbatchNo')" prop="hkbatchNo">
            <div >
              <el-input v-model="TraderecordRespVo.hkbatchNo" :placeholder="$t('showMerTranSactionSettlemenListInfo.hkbatchNo')" clearable />
              <!--              <el-button type="text" @click="openMoreDialog('orderNo')">More</el-button>-->
            </div>
          </el-form-item>




          <el-form-item class="btn-row" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>

        <!-- 通用 More 弹窗（只保留一个）  :title="getDialogTitle" -->
        <el-dialog
          :visible.sync="moreDialogVisible"
          width="800px"
          @close="onMoreDialogClose"
        >
          <el-input
            type="textarea"
            :rows="8"
            v-model="moreInput"
            :placeholder="`请输入多个值,请使用英文逗号隔开，做到输入1000个值。例如：\nVALUE1\nVALUE2, VALUE3`"
          />
          <span slot="footer">
    <el-button @click="closeMoreDialog">取消</el-button>
    <el-button type="primary" @click="confirmMoreInput">确定</el-button>
  </span>
        </el-dialog>

        </div>
      </el-form>
    </el-card>

    <div class="action-toolbar">

      <el-button
          v-if="hasPermission('admin/showMerFormsTradeListInfo', 'downExcel')"
          :disabled="!hasSearched || selectedRowIds.length === 0"
          :loading="downloadLoading"
          @click="handleDownload"
          type="primary"
          icon="el-icon-download"
      >
        {{ $t('button.download') }}

        <span v-if="maxDownloadCount > 0" style="margin-left: 6px; font-size: 12px;">
    ({{ selectedRowIds.length }}/{{ maxDownloadCount }})
  </span>
      </el-button>

    </div>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" @selection-change="handleSelectionChange" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

<!--        <el-table-column width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio v-model="selectedRowIds" :label="scope.row.tsId">{{''}}</el-radio>
          </template>
        </el-table-column>-->

        <el-table-column width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-checkbox
                :value="selectedRowIds.includes(scope.row.tsId)"
                :disabled="!selectedRowIds.includes(scope.row.tsId) && selectedRowIds.length >= maxDownloadCount"
                @change="(val) => handleCheckChange(val, scope.row.tsId)"
            />
          </template>
        </el-table-column>


        <el-table-column prop="tsId" sortable="custom" :label="$t('showMerTranSactionSettlemenListInfo.hkbatchNo')" :min-width="columnWidths.hkbatchNo"></el-table-column>


        <el-table-column :label="$t('showMerTranSactionSettlemenListInfo.tsAmount')" :min-width="columnWidths.tsAmount">
          <template slot-scope="scope">
            <span>{{ scope.row.tsBankcurrency }} {{ scope.row.tsAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tsCreatetime" :label="$t('showMerTranSactionSettlemenListInfo.tsCreatetime')" :min-width="columnWidths.tsCreatetime"></el-table-column>
        <el-table-column prop="tsStatus" :label="$t('showMerTranSactionSettlemenListInfo.tsStatus')" :min-width="columnWidths.tsStatus"></el-table-column>
        <el-table-column prop="tsSetttime" :label="$t('showMerTranSactionSettlemenListInfo.tsSetttime')" :min-width="columnWidths.tsSetttime"></el-table-column>
        <el-table-column prop="tsSettbank" :label="$t('showMerTranSactionSettlemenListInfo.tsSettbank')" :min-width="columnWidths.tsSettbank"></el-table-column>


        <el-table-column :label="$t('showMerTranSactionSettlemenListInfo.tsFactAmount')" :min-width="columnWidths.tsFactAmount">
          <template #default="scope">
            <span>{{ scope.row.tsHkcurrency }} {{ scope.row.tsFactAmount }}</span>
          </template>
        </el-table-column>


        <el-table-column prop="tsProtestFee" :label="$t('showMerTranSactionSettlemenListInfo.tsProtestFee')":min-width="columnWidths.tsProtestFee"></el-table-column>
        <el-table-column prop="tsRefundFee" :label="$t('showMerTranSactionSettlemenListInfo.refundFee')" :min-width="columnWidths.refundFee"></el-table-column>
        <el-table-column prop="tsSettFee" :label="$t('showMerTranSactionSettlemenListInfo.settFee')" :min-width="columnWidths.settFee"></el-table-column>
        <el-table-column prop="tsMonthFee" :label="$t('showMerTranSactionSettlemenListInfo.monthfee')" :min-width="columnWidths.monthfee"></el-table-column>
        <el-table-column prop="tsAmountCurrency" :label="$t('showMerTranSactionSettlemenListInfo.amountCurrency')" :min-width="columnWidths.amountCurrency"></el-table-column>
        <el-table-column prop="proAmountStr" :label="$t('showMerTranSactionSettlemenListInfo.tsProtestAmount')" :min-width="columnWidths.tsProtestAmount"></el-table-column>
        <el-table-column prop="tsNkAmount" :label="$t('showMerTranSactionSettlemenListInfo.tsNkAmount')" :min-width="columnWidths.tsNkAmount"></el-table-column>
        <el-table-column prop="tsOtherAmount" :label="$t('showMerTranSactionSettlemenListInfo.tsOtherAmount')" :min-width="columnWidths.tsOtherAmount"></el-table-column>
        <el-table-column prop="tsSpecialAmount" :label="$t('showMerTranSactionSettlemenListInfo.specialAmount')" :min-width="columnWidths.specialAmount"></el-table-column>
        <el-table-column prop="tsReturnAmount" :label="$t('showMerTranSactionSettlemenListInfo.returnAmount')"  :min-width="columnWidths.returnAmount"></el-table-column>
        <el-table-column prop="succCountStr" :label="$t('showMerTranSactionSettlemenListInfo.tsMsuccCount')" :min-width="columnWidths.tsMsuccCount"></el-table-column>
        <el-table-column prop="proCountStr" :label="$t('showMerTranSactionSettlemenListInfo.tsMproCount')" :min-width="columnWidths.tsMproCount"></el-table-column>
        <el-table-column prop="proRateStr" :label="$t('showMerTranSactionSettlemenListInfo.tsMproRate')" :min-width="columnWidths.tsMproRate"></el-table-column>
        <el-table-column prop="tsRemrak" :label="$t('showMerTranSactionSettlemenListInfo.tsRemrak')" :min-width="columnWidths.tsRemrak"></el-table-column>

      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>
  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      pickFirstDate: null,

      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          // 记录第一次选择的日期
          this.pickFirstDate = minDate.getTime();
          // 如果已经选择了两个日期，重置
          if (maxDate) {
            this.pickFirstDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果已经选择了第一个日期，限制30天范围
          if (this.pickFirstDate) {
            const day = 30 * 24 * 3600 * 1000; // 30天
            const maxTime = this.pickFirstDate + day;
            const minTime = this.pickFirstDate - day;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
          return false;
        }
      },
  /*    MAX_DAYS: 32,
      startDatePickerOptions: {
        disabledDate: (time) => {
          const endDate = this.TraderecordRespVo.endDate;
          if (!endDate) return false; // 未选结束时间时不限制

          const endTs = new Date(endDate).getTime();
          const minStart = endTs - this.MAX_DAYS * 24 * 3600 * 1000;

          // 禁用：晚于结束时间 OR 早于(结束时间-32天)
          return time.getTime() > endTs || time.getTime() < minStart;
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          // ========== 新增：获取初始生成的结束时间作为绝对上限 ==========
          const yesterday = new Date();
          //yesterday.setDate(yesterday.getDate() - 1);
          yesterday.setHours(23, 59, 59, 999);
          const initialEndTs = yesterday.getTime();
          // ============================================================

          // 超过初始结束时间 → 直接禁用（最高优先级）
          if (time.getTime() > initialEndTs) return true;

          const startDate = this.TraderecordRespVo.startDate;
          if (!startDate) return false; // 未选开始时间时，只受上面的绝对上限限制

          const startTs = new Date(startDate).getTime();
          const maxEnd = startTs + this.MAX_DAYS * 24 * 3600 * 1000;

          // 禁用：早于开始时间 OR 晚于(开始时间+32天)
          return time.getTime() < startTs || time.getTime() > maxEnd;
        }
      },*/
      loading: false,
      TraderecordRespVo: {
        dateRange:[],
        startDate: "",
        endDate: "",
        hkbatchNo: "",

        sortField: undefined,
        sortOrder: undefined
      },
      selectedRowIds:[],// 选择id
      maxDownloadCount: 0,// 可以下载数量
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      downloadLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",


    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    // 组件创建后设置默认时间
    //this.setDefaultTime(); //时间设置
    this.getSettlDown();// 或者可以下载条数
  },
  computed: {


  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.TraderecordRespVo.sortField = undefined;
        this.TraderecordRespVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.TraderecordRespVo.sortField = prop;
        this.TraderecordRespVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    //时间格式
    formatTime(isoTime) {
      if (!isoTime) return '-';

      try {
        const date = new Date(isoTime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return isoTime; // 如果解析失败，返回原值
      }},

    setDefaultTime() {
      // 只有在当前时间为空时才设置默认值
      if (!this.TraderecordRespVo.startDate) {
        this.TraderecordRespVo.startDate = this.getDefaultStartTime();
      }
      if (!this.TraderecordRespVo.endDate) {
        this.TraderecordRespVo.endDate = this.getCurrentTime();
      }
    },
    // 获取当前时间字符串，格式：YYYY-MM-DD HH:mm:ss
    getCurrentTime() {
      // return this.formatDateTime(new Date());
      const now = new Date();
      // 设置为当天 23:59:59
      now.setHours(23, 59, 59, 999); // 时, 分, 秒, 毫秒
      return this.formatDateTime(now);
    },
    // 获取当前时间往前推 1 年
    getDefaultStartTime() {
      /*    const now = new Date();
          const oneYearAgo = new Date(now);
          oneYearAgo.setFullYear(now.getFullYear() - 1);
          return this.formatDateTime(oneYearAgo);*/
      const now = new Date();

      // 1. 获取当前时间的毫秒时间戳
      const currentTimestamp = now.getTime();

      // 2. 计算2天的毫秒数 (2 * 24小时 * 60分钟 * 60秒 * 1000毫秒)
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000;

      // 3. 用当前时间戳减去2天的毫秒数
      const twoDaysAgoTimestamp = currentTimestamp - twoDaysInMs;

      // 4. 基于新的时间戳创建日期对象
      const twoDaysAgo = new Date(twoDaysAgoTimestamp);

      // 5. 重置为当天 00:00:00 (注意：这里重置的是"2天前"那天的0点)
      twoDaysAgo.setHours(0, 0, 0, 0);

      return this.formatDateTime(twoDaysAgo);
    },
    // 格式化日期为 'YYYY-MM-DD HH:mm:ss'
    formatDateTime(date) {
      const pad = (num) => String(num).padStart(2, '0');
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        if (!this.TraderecordRespVo.dateRange || this.TraderecordRespVo.dateRange.length === 0) {
          this.$message.warning(this.$t('selectDateRange'));
          return;
        }
        if(this.TraderecordRespVo.dateRange){

          this.TraderecordRespVo.startDate =
              this.TraderecordRespVo.dateRange[0];


          this.TraderecordRespVo.endDate =
              this.TraderecordRespVo.dateRange[1];

        }
        const params = {
          startDate: this.TraderecordRespVo.startDate || undefined,
          endDate: this.TraderecordRespVo.endDate || undefined,
          hkbatchNo: this.TraderecordRespVo.hkbatchNo || undefined,

          sortField: this.TraderecordRespVo.sortField || undefined,
          sortOrder: this.TraderecordRespVo.sortOrder || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/traderecord/mer/forms/tranSettlement/list',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 获取下载个数
    async getSettlDown(){
      try {
        const res = await this.$axios.post('/api/traderecord/settl/down' );
        if (res.data.code === 0) {
          this.maxDownloadCount = res.data.data || 0;

        } else {
          this.$message.error(res.data.msg);

        }
      }catch (e){
        console.error('getSettlDown error:', e);
      }

    },
    handleSelectionChange(selection) {
      if (selection.length > this.maxDownloadCount) {
        this.$message.warning(
            `最多只能选择 ${this.maxDownloadCount} 条数据进行下载`
        );
        // 超出上限时，只保留前 N 条
        this.selectedRowIds = selection.slice(0, this.maxDownloadCount);
        // 强制刷新表格选中状态（解决 el-table 选中不同步问题）
        this.$nextTick(() => {
          this.$refs.tableRef.clearSelection();
          this.selectedRowIds.forEach(row => {
            this.$refs.tableRef.toggleRowSelection(row, true);
          });
        });
        return;
      }
      this.selectedRowIds = selection.map(item => item.tsId);
    },

    handleCheckChange(checked, tsId) {
      if (checked) {
        // 勾选时校验上限
        if (this.selectedRowIds.length >= this.maxDownloadCount) {
          this.$message.warning(`最多只能选择 ${this.maxDownloadCount} 条数据`);
          return;
        }
        this.selectedRowIds.push(tsId);
      } else {
        // 取消勾选
        this.selectedRowIds = this.selectedRowIds.filter(id => id !== tsId);
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowIds = row.tsId;

    },
    // 下载报表
    async handleDownload() {



      if (!this.selectedRowIds || this.selectedRowIds.length === 0) {
        this.$message.warning(this.$t('common.pleaseSelectOneRecord'));
        return;
      }
      this.$message.info(this.$t('DownloadInfo'));


      const params = {
        ids:this.selectedRowIds
      };

      try {



        // 下载 API
        const res = await this.$axios.post('/api/traderecord/mer/forms/tranSettlement/info/down', params, {
          responseType: 'blob'
        });


        if (res.data.type === 'application/json' || (res.headers['content-type'] && res.headers['content-type'].includes('application/json'))) {
          const reader = new FileReader();
          reader.onload = () => {
            const errorData = JSON.parse(reader.result);
            this.$message.error(errorData.msg || '导出失败');
          };
          reader.readAsText(res.data);
          return;
        }
        // 构造 Blob 对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        });
        if (res.headers['x-export-truncated'] === 'true') {
          const original = res.headers['x-export-original-size'];
          const exported = res.headers['x-exported-size'];
          const warningText = this.$t('export_truncated_warning').replace('{exported}', exported).replace('{original}', original);
          this.$message.warning(warningText);
        }

        let fileName = `查询月度对账数据报表下载_${new Date().getTime()}.xls`;

        const disposition = res.headers['content-disposition'];
        if (disposition) {
          const utf8Match = /filename\*=utf-8''([^;\s]+)/i.exec(disposition);
          const normalMatch = /filename="?([^";\s]+)"?/i.exec(disposition);

          if (utf8Match && utf8Match[1]) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (normalMatch && normalMatch[1]) {
            try { fileName = decodeURIComponent(normalMatch[1]); }
            catch (e) { fileName = normalMatch[1]; }
          }
        }

        // 创建隐藏的 <a> 标签实现下载
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载

        // 清理资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href); // 释放掉blob对象

        this.$message.success('导出成功');

      }catch (e){
        console.error('下载失败', e);

        if(e.response){
          console.log('状态码:', e.response.status);
          console.log('返回内容:', e.response.data);
        }
      }


    },
    // 下载表单提交处理
    onDownloadSubmit() {
      if (!this.hasSearched) {
        this.$message.warning('请先点击【查询】按钮，再进行下载');
        return false; // 阻止表单提交
      }

      this.$message.success('开始生成文件，请查看浏览器下载列表...');

      return true; // 允许表单提交
    },
    // 通用打开弹窗方法
    openMoreDialog(fieldName) {
      this.currentField = fieldName;
      const currentValue = this.TraderecordRespVo[fieldName] || '';
      // 直接显示原始内容（可能含逗号、空格等）
      this.moreInput = currentValue;
      this.moreDialogVisible = true;
    },


    confirmMoreInput() {
      // 只需要去掉 # 前后的空格，保留值内部的其他空格
      const cleanedValue = this.moreInput
        .split('#')
        .map(item => item.trim())  // 去掉每个值的前后空格
        .filter(item => item.length > 0)  // 过滤空值
        .join('#');  // 用 # 重新连接

      this.TraderecordRespVo[this.currentField] = cleanedValue;
      this.closeMoreDialog();

      this.$message.success(`已设置 ${cleanedValue.split('#').length} 个值`);
    },

    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

    // 表头宽度
    initColumnWidths() {
      const cols = [
        'hkbatchNo',
        'tsAmount',
        'tsCreatetime',
        'tsStatus',
        'tsSetttime',
        'tsSettbank',
        'tsFactAmount',
        'tsProtestFee',
        'refundFee',
        'settFee',
        'monthfee',
        'amountCurrency',
        'tsProtestAmount',
        'tsNkAmount',
        'tsOtherAmount',
        'specialAmount',
        'returnAmount',
        'tsMsuccCount',
        'tsMproCount',
        'tsMproRate',
        'tsRemrak'
      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `showMerTranSactionSettlemenListInfo.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
/*隐藏此刻*/
.no-now-btn .el-picker-panel__link-btn.el-button--text {
  display: none;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 300px !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}
/* 三列铺满整个卡片 */
.query-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  /*column-gap: 80px;*/
  column-gap: clamp(24px, 5vw, 80px);
  row-gap: 0;
  width: 100%;
}
/* 输入框 */
/*.query-card /deep/ .el-input,
.query-card /deep/ .el-select,
.query-card /deep/ .el-date-editor {
  width: 200px !important;
}*/

.query-card /deep/ .el-input,
.query-card /deep/ .el-select {
  width:200px !important;
}


.query-card /deep/ .el-date-editor {
  width:300px !important;
}
/* 每个查询条件 */
.query-card /deep/ .el-form-item {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 18px !important;
}
/* 按钮独占一行 */
.btn-row {
  grid-column: 1 / -1;

  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 20px !important;
  margin-bottom: 0 !important;
}

/* 按钮 */
.btn-row ::v-deep .el-button {
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 10px 24px !important;
  border-radius: 6px !important;
  min-width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/view/transactionSettlement/showMerTranSactionSettlemenListInfo.vue